<script>
import { defineComponent, inject, computed } from "vue"
import NavMainSearch from "@kit/components/NavMainSearch.vue"
import { searchWidgetMain, navbar } from "@project/themes"
import NavBarBase from "@kit/components/NavBarBase.vue"
import IconButton from "@kit/components/IconButton.vue"
import { getEnv } from "@kit/utils/EnvironmentHelper"
import { cmsasset } from '@kit/utils/Formats'
import { KitColor } from '@kit/utils/Colors'
import { useRoute } from 'vue-router'
import "@css/index.css" 


export default defineComponent({
  name: "NavBar",
  setup() {
    const hydrate = inject('hydrate')

    const { prefetch } = hydrate({
      prefetch:["navAndFooter"]
    })

    // const okToShow = computed(() => {
    //   return route.name != 'contact-us' && route.name != 'gtfsrt'
    // })


    return { 
      navbar, 
      cmsasset,
      prefetch
    };
  },
  components: {
    NavBarBase,
  },
});
</script>

<style>

/*********************  

Navbar CSS 

***********************/

.hamburger-button {
  display:none !important;
}

/* Add --attop options for the nav item style */
.nav-top-option.navbar-item--attop, .nav-top-option.nav-dropdown-item--attop {
  cursor: pointer;
  padding:30px;
  padding-bottom:20px;
  padding-top:15px;
  z-index:2;
  color:white;
  font-size:1.7rem;
  font-family: "interstate-condensed", sans-serif;
  font-weight: 700;
}
.nav-top-option {
  cursor: pointer;
  padding:10px;
  padding-bottom:5px;
  padding-top:5px;
  font-size:1.1rem;
  font-family: "interstate-condensed", sans-serif;
  color:white;
}
.nav-top-option:hover {
  text-decoration: underline;
}


.hta-top-nav-subitems.navbar-subitems > .sb{
  background: #EEEEEE;
  color: #555555;
  padding:5px 15px 5px 15px;
  font-weight: normal;
}
.hta-top-nav-routes-subitems {
  width:300px !important;
}
.hta-top-nav-routes-subitems > a {
  font-size:1rem !important;
  padding:10px !important;
}


/*add --attop options for the RideHumboldt logo */
.navbar-banner-top-area.navbar-banner-top-area--attop > .hta-desktop-logo-container {
  height:70px !important;
  padding-left:60px;
}
.navbar-banner-top-area > .hta-desktop-logo-container {
  height:25px !important;
  padding-left:20px;
  margin-bottom:10px;
}

/* 
add --attop behavior for the nav area. We're going to 
shift it over and up so that it's one line */
.navbar-banner-nav-area.navbar-banner-nav-area--attop {
  padding-right:20px;
  transform:translateY(0px);
}
.navbar-banner-nav-area {
  padding-right:100px;
  transform:translateY(-45px);
}

/* this is the logo wrapper that shows up in the mobile version of the navbar. */
.navbar-logo-wrapper:not(.navbar-logo-wrapper--at-top) {
  padding:5px;
}

.navbar-logo-wrapper--at-top {
  padding:10px;
}









</style>

<template>
  <NavBarBase :theme="navbar">

    <template v-slot:top-area>

      <div v-if="prefetch && prefetch.navAndFooter"
        :class="prefetch.navAndFooter.title_logo_container_classes" 
        :style="prefetch.navAndFooter.title_logo_container_css_style">
        <img :src="cmsasset(prefetch.navAndFooter.title_logo.guid)" 
          :class="prefetch.navAndFooter.title_logo_classes" 
          :style="prefetch.navAndFooter.title_logo_css_style"
          :alt="prefetch.navAndFooter.title_logo_aria_alt_text">
      </div>

<!--  
      <div class="sb sb-spread" v-if="prefetch && prefetch.navAndFooter">
        <img :src="prefetch.navAndFooter.title_logo.guid" 
          style="object-fit:contain; height:100%; width:100%;"
          :alt="prefetch.navAndFooter.title_logo_aria_alt_text">
      </div>
-->
      
    </template>

    <template v-slot:nav-area="{ navItemClasses, dropDownNavItemClasses, navSubItemClasses }">        
    </template>
  </NavBarBase>
</template>
